import { Component, TRANSLATIONS, LOCALE_ID } from '@angular/core';
import { DataService } from './data.service';
import { Utilitats } from './lib/utilitats';
import { I18n } from '@ngx-translate/i18n-polyfill';

declare const require; // Use the require method provided by webpack

export let transfactory = (locale) => {
  locale = locale || 'en'; // default to english if no locale provided
  return require(`raw-loader!../i18n/messages.${locale}.xlf`);
};

export let transServiceProvider = {
  provide: TRANSLATIONS,
  useFactory: transfactory,
  deps: [LOCALE_ID]
};

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  providers: [
    DataService,
    Utilitats,
    transServiceProvider,
    I18n]
})
export class AppComponent {
  title = 'app';

  constructor() {}
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts